export class UpdateLpmModel {
    companySurrKey: number;
    lpmName: string;
}